import axios from 'axios'
import {NOTIFICATION_DANGER, NOTIFICATION_WARNING} from '@/constants/common';
import router from '../../router/main';

// initial state
const state = {
    loading : false,
    posts: [],
    relatedPosts: [],
    tags: [],
    activeTags: [],
    activePost: {},
    currentPostVersions : false,
    postComments : [],
    oldPostComments : [],
    fullScreen: false,
    currentPage: 1,
    hasMorePages: false,
    search: ''
};

// getters
const getters = {
    posts: state => {
        return state.posts;
    },
    getTagsIds: state => {
        let array = [];
        state.tags.forEach((item) => {
            array.push(item.id);
        });
        return array;
    },
    getPostTags: state => tags => {
        if (!tags) {
            return [];
        }
        let result = [];
        tags.forEach((tag) => {
            let index = state.tags.findIndex(x => x.id === tag);
            if (index > -1) {
                result.push(state.tags[index]);
            }
        });

        return result
    },
    getVersions: state => {
        return state.currentPostVersions;
    },
    getCommentTarget: state => id =>{
        let target = state.postComments.find(x => x.id === id);
        return target.author
    },
    search: state => {
        return state.search;
    }
};

// actions
const actions = {
    getAllPosts({commit, state}) {
        commit('setPosts', []);
        commit('setLoading', true);
        axios.get('/api/articles/posts', {
            params: {
                tags: state.activeTags,
                search: state.search,
                page: 1
            }
        })
            .then((response) => {
                if (!response.data.error) {
                    commit('setPosts', response.data.posts);
                    commit('setPage', response.data.currentPage);
                    commit('setMorePages', response.data.hasMorePages);
                    commit('setLoading', false);
                } else {
                    this.dispatch('pushNotification', {type: NOTIFICATION_WARNING, text: response.data.message, time: 10000})
                }
            })
            .catch((error) => {
                this.dispatch('errorHandler', error)
            });
    },
    getPostsAfterTagClick({commit, state}, id) {
        commit('setLoading', true);
        commit('setPosts', []);
        commit('setFullScreen', false);
        commit('setActiveTag', id);

        axios.get('/api/articles/posts', {
            params: {
                tags: state.activeTags,
                search: state.search,
                page: 1
            }
            })
            .then((response) => {
                if (!response.data.error) {
                    commit('setPosts', response.data.posts);
                    commit('setLoading', false);
                } else {
                    this.dispatch('pushNotification', {type: NOTIFICATION_WARNING, text: response.data.message, time: 10000})
                }
            })
            .catch((error) => {
                this.dispatch('errorHandler', error)
            });
    },
    getMorePosts({commit, state}) {
        if (state.hasMorePages) {
            commit('setLoading', true);
            axios.get('/api/articles/posts', {
                params: {
                    tags: state.activeTags,
                    search: state.search,
                    page: state.currentPage + 1
                }
            })
                .then((response) => {
                    if (!response.data.error) {
                        console.log(response.data.posts);
                        commit('pushPosts', response.data.posts);
                        commit('setPage', response.data.currentPage);
                        commit('setMorePages', response.data.hasMorePages);
                        commit('setLoading', false);
                    } else {
                        this.dispatch('pushNotification', {type: NOTIFICATION_WARNING, text: response.data.message, time: 10000})
                    }
                })
                .catch((error) => {
                    this.dispatch('errorHandler', error)
                });
        }
    },
    getAllTags({commit}) {
        commit('setLoading', true);
        return new Promise((resolve) => {
            axios.get('/api/articles/tags')
                .then((response) => {
                    if (!response.data.error) {
                        commit('setTags', response.data.tags);
                        commit('setLoading', false);
                        resolve();
                    } else {
                        this.dispatch('pushNotification', {type: NOTIFICATION_WARNING, text: response.data.message, time: 10000})
                    }
                })
                .catch((error) => {
                    this.dispatch('errorHandler', error)
                });
        });
    },
    getPost({commit}, {id, revision}) {
        let params = {
            id: id,
        };
        if(revision) {
            params.revision = true
        }
        return new Promise((resolve) => {
        axios.get('/api/articles/post', {
            params: params
        })
            .then((response) => {
                let data = response.data;
                if (!data.error) {
                    data.post.isRevision = data.isRevision;
                    commit('setActivePost', data.post);
                    commit('setRelatedPosts', data.similar);
                    resolve();
                    this.dispatch('knowledge/getPostComments')
                } else {
                    this.dispatch('pushNotification', {type: NOTIFICATION_WARNING, text: response.data.message, time: 10000})
                }

            })
            .catch((error) => {
                this.dispatch('errorHandler', error)
            });
        });
    },
    getPostComments({commit, state}) {
        axios.get('/api/comments', {params: {id: state.activePost.id, revision: state.activePost.isRevision}})
            .then((response) => {
                if (!response.data.error) {
                    commit('setPostComments', response.data.comments);
                    commit('setOldPostComments', response.data.oldComments);
                } else {
                    this.dispatch('pushNotification', {type: NOTIFICATION_WARNING, text: response.data.message, time: 10000})
                }
            })
            .catch((error) => {
                this.dispatch('errorHandler', error)
            });
    },
    closeActivePost({commit}) {
        commit('setActivePost', false);
        router.push({
            name: 'knowledge-base',
            query: router.currentRoute.query
        });
    },
    editComment({commit}, {id, body}) {
        return new Promise((resolve) => {
            axios.patch('/api/comments/update?id='+ id, {body: body})
                .then((response) => {
                    commit('updateComment', response.data.comment);
                })
                .catch((error) => {
                    this.dispatch('errorHandler', error)
                });
            resolve()
        });
    },
    sendComment({commit, state}, {msg, parent}) {
        return new Promise((resolve) => {
            axios.post('/api/comments/add?id=' + state.activePost.id, {parent_id: parent, body: msg})
                .then((response) => {
                    commit('pushPostComment', response.data.comment);
                })
                .catch((error) => {
                    this.dispatch('errorHandler', error)
                });
            resolve()
        });
    },
    deleteComment({commit}, id) {
        return new Promise((resolve) => {
            axios.delete('/api/comments/delete?id=' + id)
                .then(() => {
                    commit('deleteComment', id);
                })
                .catch((error) => {
                    this.dispatch('errorHandler', error)
                });
            resolve()

        });
    },
    setActiveTag({commit}, id) {
        commit('setActiveTag', id);
        commit('setFullScreen', false);
        this.dispatch('knowledge/getAllPosts')
    },
    setSearchQuery({commit}, strSearch) {
        commit('setSearchQuery', strSearch);
        commit('setFullScreen', false);
        this.dispatch('knowledge/getAllPosts')
    },
    setActiveTags({commit}, tags) {
        commit('setActiveTags', tags);
        commit('setFullScreen', false);
    },
    setFavoritePost({commit, state}, value) {
        return new Promise((resolve) => {
            setTimeout(() => {
                axios.get('/api/articles/favorite', {params: {id: state.activePost.id}})
                    .then((response) => {
                        if (!response.data.error) {
                            commit('setFavorite',value);
                            resolve();
                        } else {
                            this.dispatch('pushNotification', {type: NOTIFICATION_WARNING, text: response.data.message, time: 10000})
                        }
                    })
                    .catch((response) => {
                        console.log(response);
                        this.dispatch('pushNotification', {
                            type: NOTIFICATION_DANGER,
                            text: "Server error",
                            time: 10000
                        })
                    });
            }, 300);
        });
    },
};

// mutations
const mutations = {
    setPosts (state, posts) {
        state.posts = posts
    },
    setRelatedPosts (state, posts) {
        state.relatedPosts = posts
    },

    pushPosts (state, posts) {
        state.posts = state.posts.concat(posts)
    },
    setTags (state, tags) {
        state.tags = tags
    },
    setLoading(state, value) {
        state.loading = value;
    },
    setActivePost (state, post) {
        state.activePost = post;
    },
    setPostComments (state, comments) {
        state.postComments = comments
    },
    setOldPostComments (state, comments) {
        state.oldPostComments = comments
    },
    pushPostComment (state, comment) {
        state.postComments.push(comment)
    },
    deleteComment (state, id) {
        state.postComments.splice(state.postComments.findIndex(x => x.id === id),1)
    },
    updateComment(state, comment) {
        let index = state.postComments.findIndex(x => x.id === comment.id);
        if (index > -1) {
            state.postComments.splice(index, 1, comment)
        }
    },
    setVersions(state, versions) {
        state.currentPostVersions = versions
    },
    setFullScreen(state, value) {
        state.fullScreen = value
    },
    setActiveTag(state, id) {
        let inArr = state.activeTags.indexOf(id);
        if(inArr === -1) {
            state.activeTags.push(id)
        } else {
            state.activeTags.splice(inArr, 1)
        }
    },
    setActiveTags(state, tags) {
        state.activeTags = tags
    },
    setPage(state, page) {
        state.currentPage = page
    },
    setMorePages(state, value) {
        state.hasMorePages = value
    },
    setFavorite(state, value) {
        state.activePost.inFavorites = value
    },
    setSearchQuery(state, value) {
        state.search = value
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}